import { env } from "@/lib/env";

/**
 * Customer-facing platform brand name — the SINGLE source of truth for the
 * `(platform)` self-serve signup marketing/UI copy (SELF_SERVE_SIGNUP_PLAN
 * "build now, brand later"). Driven by `NEXT_PUBLIC_BRAND_NAME`; the `<BRAND
 * _NAME>` placeholder keeps the surface buildable + testable before the owner
 * resolves the brand. The internal codename "Kudu" is NEVER customer-facing.
 */
export const PLATFORM_BRAND_NAME = env.NEXT_PUBLIC_BRAND_NAME?.trim() || "Oluflow";

/**
 * Parent domain rendered as the `.oluflow.com` suffix on the signup form's
 * subdomain field. Display only; the authoritative value is the server-side
 * `KUDU_TENANT_SUBDOMAIN_PARENT`.
 */
export const PLATFORM_SUBDOMAIN_SUFFIX =
  env.NEXT_PUBLIC_TENANT_SUBDOMAIN_PARENT?.trim() || "oluflow.com";

/**
 * Public contact address for the marketing site's "Contact us" / "Talk to us"
 * CTAs (Enterprise + closing band). Derived from the brand domain
 * (`PLATFORM_SUBDOMAIN_SUFFIX`) so a rename flows from one env var; mirrors
 * kudu-api's live `MAIL_REPLY_TO` (`support@oluflow.com`) — the real inbox.
 */
export const PLATFORM_SUPPORT_EMAIL = `support@${PLATFORM_SUBDOMAIN_SUFFIX}`;

/** Sales / general-inquiry inbox, surfaced on the marketing Contact section. */
export const PLATFORM_SALES_EMAIL = `sales@${PLATFORM_SUBDOMAIN_SUFFIX}`;
